import * as React from 'react';
import './Masthead.css';

const Masthead = () => {
  return (
    <header
      id='masthead'
    >
      <h1>East End Cemetery</h1>
    </header>
  );
};

export default Masthead;



// WEBPACK FOOTER //
// ./src/components/Masthead.jsx